import TomSelect from 'tom-select/dist/js/tom-select.complete';
import {post} from "../modules/ajax";

export function initTomSelectQuantity(quantity)
{
    let tomSelect = new TomSelect(quantity, {
        labelField: 'value',
        searchField: null,
        create: false,
        maxOptions: 101,
        controlInput: null,
        plugins: ['no_backspace_delete',],
        dropdownParent: quantity.dataset.sizeBoxContainer ? '#' + quantity.dataset.sizeBoxContainer : null,
        onFocus: function() {
            quantity.parentElement.dataset.tsopen = 'true';
        },
        onBlur: function () {
            setTimeout(() => quantity.parentElement.dataset.tsopen = 'false', 100);
        },
        render: {
            option: function(data, escape) {
                if (data.price) {
                    return `
                            <div>
                                <span class="item-quantity">${escape(data.quantity)}</span>
                                <span class="item-price">${escape(data.price)}</span>
                            </div>
                        `;
                } else {
                    return `
                            <div>
                                <span class="item-quantity">${(data.quantity ? escape(data.quantity) : '0')}</span>
                            </div>
                        `;
                }
            }
        }
    });

    tomSelect.sync();

    return tomSelect;
}

export function getNewTomSelectQuantity(productId, sizeBoxId, price)
{
    try {
        return new Promise(resolve => {
            post(
                '/ajax/website/product/get-quantity-selector',
                {
                    productId: productId,
                    sizeBoxId: sizeBoxId,
                    price: price

                },
                function (response) {
                    resolve(response.view);
                },
                function (response) {
                    resolve(null);
                }
            );
        });
    } catch (e) {
        return null;
    }
}